import {
  time_zone_options
} from 'constants/TimezoneOptions.constants';

const initialState = {
  tzOptions: [],
  isLoading: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case time_zone_options.SUCCESS:
      return { ...state, tzOptions: action.payload };
    case time_zone_options.LOADING:
      return { ...state, isLoading: action.payload };
    default:
      return state;
  }
};

export default reducer;
